<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import LocaleChanger from '../../components/LocaleChanger.vue';
import messages from './locales/messages'
import { fetchInstagramPhotos } from '@/api/instagram';

const { t, locale, availableLocales, getLocaleMessages, mergeLocaleMessage } = useI18n({
  useScope: 'global',
  messages
})

const insta_data = ref([]);

const insta_photos = computed(()=>{
    return insta_data.value.map((photo)=>{
        if(photo.thumbnail_url){
            return {
                src: photo.thumbnail_url,
                alt: photo.caption,
                link: photo.permalink
            }
        }
        else{
            return {
                src: photo.media_url,
                alt: photo.caption,
                link: photo.permalink
            }
        }
    })
})
const languages_list = computed(()=>{
    //return [];
    return availableLocales.map((lang)=>{
        return {
            label: t(`lang_${lang}`),
            value: lang
        }
    });
})
onMounted(()=>{
    fetchInstagramPhotos().then((data)=>{
        insta_data.value = data;
    })
})
</script>
<template>
    <div id="insta_footer">
        <Vue3Marquee id="insta_photos" pauseOnHover :duration="insta_photos.length * 5">
            <a v-for="(photo, index) in insta_photos" :key="index" :href="photo.link" target="_blank"><img :src="photo.src" :alt="photo.alt" class="insta_photo" /></a>
        </Vue3Marquee>
        <div id="insta_link">
            <a href="https://www.instagram.com/kasefiltersfrance/" target="_blank">
                <v-icon size="25" alt="Instagram">mdi-instagram</v-icon>
               <span v-html='t("instagram_follow").replaceAll("\n","<br />")'></span>
            </a>
        </div>
    </div>
    <footer>
        <div class="content">
        <router-link :to="{name:locale+'.home'}">
            <img src="@/assets/logos/logo_kase_FR_Blanc_Desktop.png" 
            srcset="@/assets/logos/logo_kase_FR_Blanc_Desktop.png, @/assets/logos/logo_kase_FR_Blanc_Desktop.png 2x" 
            id="footer_logo"
            alt="Kase France" />
        </router-link>
        <!--<LocaleChanger />-->
        <nav>
            <ul>
                <li>
                    <h3>Informations</h3>
                    <ul>
                        <li><router-link :to="{name:locale+'.aboutus'}">{{ t('menu.about') }}</router-link></li>
                        <li><router-link :to="{name:locale+'.aboutkase'}">{{ t('menu.aboutkase') }}</router-link></li>
                        <li><router-link :to="{name:locale+'.contact'}">{{ t('menu.contact')}}</router-link></li>
                        <li><router-link :to="{name:locale+'.shipping'}">{{ t('menu.shipping') }}</router-link></li>
                        <li><router-link :to="{name:locale+'.return'}">{{ t('menu.return')}}</router-link></li>
                        <li><router-link :to="{name:locale+'.tcs'}">{{ t('menu.cgv')}}</router-link></li>
                        <li><router-link to="/secure">{{ t('menu.secure')}}</router-link></li>
                        <li><router-link :to="{name:locale+'.account'}">{{ t('menu.compte')}}</router-link></li>
                        <li><CookieConcent /></li>
                    </ul>
                </li>
                <li>
                    <h3>{{(t('menu.links'))}}</h3>
                    <ul class="col-1">
                        <li><router-link :to="{name:locale+'.category_sales'}">{{ t('menu.promo')}}</router-link></li>
                        <!--<li><router-link to="/ambassadeurs">{{ t('menu.ambassadeurs') }}</router-link></li>-->
                        <!--<li><router-link to="/blog">{{t('menu.blog')}}</router-link></li>-->
                        <li><a href="https://www.facebook.com/KaseFiltersFR" target="_blank">{{t('menu.facebook')}}</a></li>
                        <li><a href="https://www.instagram.com/kasefiltersfrance/" target="_blank">{{t('menu.instagram')}}</a></li>
                        <!--<li><a href="">{{t('menu.autres_pays')}}</a></li>-->
                    </ul>
                </li>
            </ul>
        </nav>
        
        <router-link to="/secure" id="secure_link">
            <img src="@/assets/logos/paiement_secure.png" id="secure_img" alt="Paiement sécurisé" />
            <div
                data-pp-message
                data-pp-style-text-color="white"
                data-pp-style-text-align="center"
                data-pp-style-layout="text"
                data-pp-placement=home>
            </div>
        </router-link>
        <p>{{$t('footer_disclaimer')}}</p>
        </div>
    </footer>
</template>
<style lang="scss" scoped>
#insta_footer{
    display: flex;
    justify-content: center;
    flex-direction: column;

    #insta_link{
        display: flex;
        justify-content: start;
        width: 100%;
        height: 87px;
        background: #F52B2B;
        padding: 20px;
        font-family: Montserrat;
        font-size: 24px;
        font-weight: 600;
        line-height: 29.26px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        a{
            position: relative;
            display: block;
            width: 100%;
            text-transform: uppercase;
            color: #FFF;
            text-decoration: none;font-family: Montserrat;
            font-size: 18px;
            font-weight: 600;
            line-height: 21.94px;
            text-align: left;
            text-underline-position: from-font;
            text-decoration-skip-ink: none;

            
            i{
                font-size: 35px !important;
                display: block;
                margin-left: auto;
                margin-right: 0;
                position: absolute;
                right: 20px;
                top: calc(50% - 17.5px);
            }

        }

    }
    #insta_photos{
        display: flex;
        width: 100%;
        height: 157px;
        flex-direction: row;
        overflow: hidden;
        white-space: nowrap;

        a {
            flex: 0 0 auto;
            img.insta_photo{
                width: 188px;
                height: 161px;
                object-fit: cover;
            }
        }
    }
    
    
}
footer{
    display: flex;
    flex-direction: column;
    background: linear-gradient(257.47deg, #3C5A6B -8.78%, #0E2E5B 110.74%);
    padding: 38px 20px;
    .content{
        display: flex;
        position: relative;
        flex-direction: column;
        margin: 0 auto;
        width:  $responsive_point;
        max-width: 100%;
    }
    img#footer_logo{
        width: 106px;
        max-width: calc(100% - 30px);
        margin-left: 30px;
    }
    img#secure_img{
        margin-left: 30px;
        width: 292px;
        max-width: calc(100% - 30px);
    }
    #secure_link{
        text-decoration: none;
    }
    .locale-changer{
        margin-left: 30px;
        margin-top: 20px;
    }
    p{
        padding-top: 20px;
        font-weight: 600;
        color: #FFF;
        font-size: 10px;
        line-height: 12px;
        text-align: center;
    }
    nav{
        padding: 20px 30px;
        h3{
            text-transform: uppercase;
            font-size: 16px;
            line-height: 20px;
            color: #FFF;
            font-weight: bold;
        }
        ul{
            list-style: none;
            padding-top: 11px;
            li{
                font-size: 14px;
                line-height: 20px;
                :deep(a){
                    color: #FFF;
                    text-decoration: none;
                    text-wrap: nowrap;
                    &:hover{
                        text-decoration: underline;
                    }
                }
            }
        }
    }
    
}
@media only screen and (min-width : $responsive-point) {
    #insta_footer{
        display: flex;
        justify-content: center;
        height: 250px;
        flex-direction: row;

        #insta_link{
            height: 100%;
            display: flex;
            justify-content: start;
            align-items: center;
            width: calc(50% - 250px);
            background: #F52B2B;
            padding: 20px;
            font-family: Montserrat;
            font-size: 24px;
            font-weight: 600;
            line-height: 29.26px;
            text-align: left;
            text-underline-position: from-font;
            text-decoration-skip-ink: none;
            a{
                max-width: 200px;
                text-transform: uppercase;
                color: #FFF;
                text-decoration: none;
                i{
                    position: absolute;
                    font-size: 35px;
                    margin-bottom: 1rem;
                    right: auto;
                    left: auto;
                    margin-right: auto;
                    margin-left: 0;
                    top: -45px;
                }
            }

        }
        #insta_photos{
            display: flex;
            width: calc(50% + 250px);
            height: 255px;
            flex-direction: row-reverse;
            overflow: hidden;
            white-space: nowrap;

            a {
                flex: 0 0 auto;
                img.insta_photo{
                    width: 255px;
                    height: 255px;
                    object-fit: cover;
                }
            }
        }
        
        
    }
    footer{
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        .content{
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
        }
        img#footer_logo{
            order: 1;
            width: 106px;
        }
        #secure_link{
            order: 2;
            z-index: 101;
            width: 292px;
            img#secure_img{
                width: 292px;
            }
        }
        nav{
            margin-top: -130px;
            order: 3;
            z-index: 100;
            width: 100%;
            position: relative;
            // first level ul should display inline seconde level ul should display block
            ul{
                display: flex;
                justify-content: space-between;
                width: 100%;
                li{
                    &:first-child{
                        width: 50%;
                    }
                    &:last-child{
                        width: 40%;
                    }
                    
                    ul{
                        display: block;
                        &.col-1{
                            column-count: 1;
                        }
                    }
                }
            }
            ul{
                position: relative;
                width: 100%;
                column-count: 2;
                
            }
            ul.col1{
              
                    column-count: 1;
            
            }
        }

        p{
            order: 4;
            width: 100%;
        }

    }
}
</style>